export const enChatbotTranslations = {
	chatbot: {
		title: 'Menu Assistant',
		subtitle: 'Ask me anything!',
		welcome: 'Welcome!',
		welcomeMessage: 'Hi! I\'m here to help you explore our menu. What would you like to know?',
		inputPlaceholder: 'Ask about our menu...',
		thinking: 'Thinking',
		clearChat: 'Clear chat',
		suggestedItems: 'Recommended for you',
		hints: [
			'👋 Hi! I\'m here to help you',
			'🍽️ Ask me about our menu!',
			'✨ Need help choosing?',
			'🤖 Your food assistant is ready!',
			'🍕 What looks delicious today?',
			'📋 Let me help you order!',
			'🌟 Discover our specialties!',
			'🔍 Search our menu with me!'
		],
		quickActions: {
			viewMenu: 'View menu',
			vegetarianOptions: 'Vegetarian options',
			popularDishes: 'Popular dishes',
			todaySpecial: 'Today\'s special'
		},
		fetchingDatabase: "Fetching data from database",
		processingRequest: "Processing your request",
		searchingMenu: "Searching through menu items",
		physicalKeyboardHint: "Enter to send, Shift+Enter for new line",
		virtualKeyboardHint: "Enter for new line",
		inputPlaceholderPhysical: "Type your message...",
		inputPlaceholderVirtual: "Type your message...",
		minimize: 'Minimize',
		maximize: 'Maximize',
		close: 'Close'
	}
};